<template>
  <div class="content">
    <v-app class="bg-transparent">
      <div>
        <v-main>
          <!-- ---------------LOADER PROCESANDO DATOS ---------------- -->
          <div v-if="cargando">
            <loader
              object="#4caf50"
              color1="#ffffff"
              color2="#17fd3d"
              size="5"
              speed="2"
              bg="#343a40"
              objectbg="#999793"
              opacity="40"
              disableScrolling="false"
              name="box"
            ></loader>
          </div>
          <div class="flex justify-end ">
            <v-btn
              class="mb-4 mr-3 text-white"
              color="green"
              @click="dialog = true; cargarCategorias()"
            >
              Nuevo Ticket
              <v-icon class="ml-1" prepend-icon small>mdi-cards-outline</v-icon>
            </v-btn>
          </div>
          <v-container fluid class="bg-white rounded">
            <v-alert
              v-if="sinVinculoSoporte"
              type="warning"
              border="left"
              class="mb-4"
              dismissible
            >
              {{ mensajeVinculo }}
            </v-alert>
            <v-alert
              v-if="errorMensaje"
              type="error"
              border="left"
              class="mb-4"
              dismissible
              @input="errorMensaje = ''"
            >
              {{ errorMensaje }}
            </v-alert>
            <v-alert
              v-if="mensajeExito"
              type="success"
              border="left"
              class="mb-4"
              dismissible
              @input="mensajeExito = ''"
            >
              {{ mensajeExito }}
            </v-alert>
            <div class="card">
              <div class="card-header card-header-success">
                <h4 class="card-title">Soportes</h4>
                <p class="card-category"></p>
              </div>
              <template>
                <!-- Filtros (búsqueda y estado) -->
                <div class="filters-bar d-flex flex-wrap align-center pa-3" style="gap: 12px;">
                  <v-text-field
                    v-model="searchInput"
                    placeholder="Buscar en asunto o consulta..."
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    dense
                    hide-details
                    outlined
                    style="max-width: 360px;"
                    @keyup.enter="aplicarFiltros"
                    @click:clear="aplicarFiltros"
                  />
                  <v-select
                    v-model="estadosFiltroInput"
                    :items="estados"
                    item-text="text"
                    item-value="value"
                    placeholder="Progreso"
                    multiple
                    chips
                    small-chips
                    clearable
                    dense
                    hide-details
                    outlined
                    style="min-width: 280px; max-width: 420px;"
                    @change="aplicarFiltros"
                  />
                  <v-select
                    v-model="categoriaFiltroInput"
                    :items="categoriasFiltroOptions"
                    item-text="text"
                    item-value="value"
                    placeholder="Categoría"
                    no-data-text="No se encontraron categorías"
                    multiple
                    chips
                    small-chips
                    clearable
                    dense
                    hide-details
                    outlined
                    style="min-width: 280px; max-width: 420px;"
                    @change="aplicarFiltros"
                  />
                  <v-btn
                    color="primary"
                    small
                    :disabled="!hayFiltrosActivos"
                    @click="aplicarFiltros"
                  >
                    <v-icon left small>mdi-filter</v-icon> Filtrar
                  </v-btn>
                  <v-btn
                    color="grey"
                    small
                    outlined
                    :disabled="!hayFiltrosActivos"
                    @click="limpiarFiltros"
                  >
                    <v-icon left small>mdi-close</v-icon> Limpiar
                  </v-btn>
                </div>
                <v-data-table
                  :headers="headers"
                  :items="soportes"
                  :items-per-page="rowsPerPage"
                  :loading="cargando"
                  loading-text="Cargando... Espere por favor"
                  no-results-text="No se encontraron registros"
                  no-data-text="No se encontraron registros"
                  item-key="Id"
                  ref="tabla_soportes"
                  calculate-widths
                  hide-overlay
                  hide-default-footer
                  :footer-props="{ 'items-per-page-options': [20, 50, 100, 200] }"
                  @click:row="(item) => irADetalle(item)"
                >
                  <template v-slot:top>
                    <v-toolbar flat>
                      <!-- Modal de nuevo ticket -->
                      <v-dialog
                        v-model="dialog"
                        max-width="720px"
                        scrollable
                        @click:outside="resetConsulta()"
                        @keydown.esc="dialog = false; resetConsulta()"
                      >
                        <v-card>
                          <v-card-title class="text-h5 ">
                            
                            Crear Nuevo Ticket
                          </v-card-title>

                          <v-card-text class="pt-2">
                            <v-form ref="formSoporte" v-model="formValido">
                              <v-row dense>
                                <v-col cols="12" md="8">
                                  <v-text-field
                                    v-model="asunto"
                                    label="Asunto *"
                                    :rules="reglaConsulta"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                  <v-select
                                    v-model="categoria"
                                    :items="categoriasOptions"
                                    item-text="text"
                                    item-value="value"
                                    label="Categoría"
                                    no-data-text="No se encontraron categorías"
                                    outlined
                                    dense
                                  ></v-select>
                                </v-col>
                                <v-col cols="12">
                                  <v-textarea
                                    v-model="consulta"
                                    label="Descripción Detallada *"
                                    :rules="reglaConsulta"
                                    outlined
                                    auto-grow
                                    rows="4"
                                  ></v-textarea>
                                </v-col>
                                <v-col cols="12">
                                  <div
                                    class="drop-zone"
                                    :class="{
                                      'drop-zone--active': isDragging,
                                      'drop-zone--has': archivoC.length > 0,
                                    }"
                                    @click="triggerFileInput"
                                    @dragenter.prevent.stop="onDragEnter"
                                    @dragover.prevent.stop="onDragOver"
                                    @dragleave.prevent.stop="onDragLeave"
                                    @drop.prevent.stop="onDrop"
                                  >
                                    <input
                                      ref="ticketFileInput"
                                      type="file"
                                      accept="image/png, image/jpeg, image/webp"
                                      multiple
                                      class="drop-zone__input"
                                      @change="onFilePickerChange"
                                    />
                                    <v-icon
                                      size="32"
                                      :color="isDragging ? 'primary' : 'grey darken-1'"
                                      class="mr-2"
                                    >
                                      {{ isDragging ? "mdi-download-outline" : "mdi-cloud-upload-outline" }}
                                    </v-icon>
                                    <span class="drop-zone__title">
                                      {{
                                        isDragging
                                          ? "Soltá los archivos para adjuntarlos"
                                          : "Arrastrá tus archivos o hacé click para adjuntar"
                                      }}
                                    </span>
                                    <span class="drop-zone__hint">
                                      PNG, JPG o WEBP · Máx. 5 archivos
                                    </span>
                                  </div>

                                  <div v-if="archivoC.length" class="preview-list">
                                    <div
                                      v-for="(file, i) in archivoC"
                                      :key="file.name + '-' + i + '-' + file.size"
                                      class="preview-item"
                                    >
                                      <div class="preview-item__thumb">
                                        <img
                                          v-if="archivoCPreviews[i]"
                                          :src="archivoCPreviews[i]"
                                          :alt="file.name"
                                        />
                                        <v-icon v-else small color="grey">
                                          mdi-file-image-outline
                                        </v-icon>
                                      </div>
                                      <div class="preview-item__info">
                                        <div class="preview-item__name" :title="file.name">
                                          {{ file.name }}
                                        </div>
                                        <div class="preview-item__size">
                                          {{ formatBytes(file.size) }}
                                        </div>
                                      </div>
                                      <v-btn
                                        icon
                                        x-small
                                        @click.stop="eliminarPreview(i)"
                                      >
                                        <v-icon small>mdi-close</v-icon>
                                      </v-btn>
                                    </div>
                                  </div>
                                </v-col>
                              </v-row>
                            </v-form>
                          </v-card-text>

                          <v-divider></v-divider>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="grey"
                              class="mr-2"
                              @click="dialog = false; resetConsulta()"
                            >
                              Cancelar
                            </v-btn>
                            <v-btn
                              color="primary"
                              :loading="cargandobtn"
                              :disabled="!formValido"
                              @click="save"
                            >
                              <v-icon left small>mdi-send</v-icon>
                              Crear Ticket
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>

                      <!-- Modal de Eliminar -->
                      <!-- <v-dialog v-model="dialogDelete" max-width="500px">
                      <v-card>
                        <v-card-title class="text-h5"
                          >Seguro desea eliminar este ticket?</v-card-title
                        >
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue darken-1" text @click="closeDelete"
                            >Cancel</v-btn
                          >
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="deleteItemConfirm"
                            >OK</v-btn
                          >
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </v-dialog> -->
                    </v-toolbar>
                  </template>

                  <!-- Aqui van elementos de la tabla -->

                  <!-- Header Nro Id -->
                  <template v-slot:[`item.Id`]="{ item }">
                    {{ item.Id }}
                  </template>

                  <!-- Header Consulta -->
                  <template v-slot:[`item.Consulta`]="{ item }">
                    <div
                      class="decoration-solid text-blue-400"
                      style="cursor: pointer; text-decoration: underline;"
                      @click="irADetalle(item)"
                    >
                      {{ item.Consulta }}
                    </div>
                  </template>

                  <!-- Header Asunto -->
                  <template v-slot:[`item.Asunto`]="{ item }">
                    <a
                      href="#"
                      style="color: #1976d2; text-decoration: none;"
                      @click.prevent="irADetalle(item)"
                    >
                      {{ item.Asunto }}
                    </a>
                  </template>

                  <!-- Header Categoría -->
                  <template v-slot:[`item.Categoria`]="{ item }">
                    {{ item.Categoria || '-' }}
                  </template>

                  <!-- Header Usuario (email del solicitante) -->
                  <template v-slot:[`item.Usuario`]="{ item }">
                    <span class="user-creator">
                      {{ item.Email || '-' }}
                    </span>
                  </template>

                  <!-- Header Fecha formateada -->
                  <template v-slot:[`item.Fecha`]="{ item }">
                    {{ formatFecha(item.Fecha) }}
                  </template>

                  <!-- Header Abierta (Abierto / Cerrado) -->
                  <template v-slot:[`item.Abierta`]="{ item }">
                    <v-chip
                      small
                      :color="item.Abierta ? 'green' : 'red'"
                      text-color="white"
                      class="px-2"
                    >
                      {{ item.Abierta ? 'Abierto' : 'Cerrado' }}
                    </v-chip>
                  </template>

                  <!-- Header Estado (progreso, chip con color) -->
                  <template v-slot:[`item.Estado`]="{ item }">
                    <v-chip
                      :class="colorForEstado(item.Estado)"
                      class="pa-2 rounded-xl text-white"
                      small
                    >
                      {{ item.Estado | capitalizeFirstLetter }}
                    </v-chip>
                  </template>

                  <!-- Header Respuestas (count) -->
                  <template v-slot:[`item.Respuestas`]="{ item }">
                    <v-chip small color="blue-grey lighten-4">
                      {{ item.Respuestas }}
                    </v-chip>
                  </template>

                  <!-- Header Cliente (nombre) -->
                  <!-- <template v-slot:[`item.ClientName`]="{ item }">
                    <span 
                      v-if="item.ClientName" 
                      class="rounded font-weight-bold px-2 py-1"
                      :style="{ backgroundColor: item.ClientColor || '#6366f1', color: getContrastColor(item.ClientColor || '#6366f1') }"
                    >
                      {{ item.ClientName }}
                    </span>
                    <span v-else class="grey--text">—</span>
                  </template> -->
                  <!-- Fin de elementos de la tabla -->

                  <!-- cantidad de registros por pagina -> actualizar numero de registros por pagina -->
                  <template v-slot:footer>
                    <v-row class="no-gutters mt-2 mx-2">
                      <v-flex xs12>
                        <span>Mostrar</span>
                        <v-menu top>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              dark
                              text
                              color="primary"
                              class="ml-2"
                              v-on="on"
                            >
                              {{ rowsPerPage }}
                              <v-icon>arrow_drop_down</v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item
                              v-for="(number, index) in rowsPerPageArray"
                              :key="index"
                              @click="updateRowsPerPage(number)"
                            >
                              <v-list-item-title>{{
                                number
                              }}</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-flex>
                    </v-row>
                  </template>
                </v-data-table>
                <!-- Paginacion -->
                <div class="text-center mt-2">
                  <v-pagination
                    :value="page"
                    :length="total"
                    :total-visible="visible"
                    @input="onPageChange($event)"
                  ></v-pagination>
                </div>

                <!-- Modal de Editar Soporte -->
                <!-- <v-dialog v-model="dialogEdit" persistent max-width="1200px">
                <v-card>
                  <v-card-title>
                    <span class="text-h5">Editar Soporte</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="consultaEdit"
                            label="Consulta"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-file-input
                            v-model="archivo"
                            label="Archivo(opcional)"
                          ></v-file-input>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="dialogEdit = false"
                    >
                      Close
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="editarSoporte()">
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog> -->
                <!-- Fin de Modal de Editar Soportes -->
              </template>
              <!-- Fin de template de tabla -->

              <!-- Modal Respuestas-->
              <v-dialog
                v-model="dialogRespuestas"
                width="1000"
                @click:outside="resetRespuesta()"
                @click:esc="dialogRespuestas = false"
              >
                <v-card>
                  <v-card-title class="text-h5 grey lighten-2">
                    <v-icon class="mr-2">mdi-umbrella</v-icon>
                    Ticket Nro:
                    <span>{{ itemConsulta.toString().padStart(6, "0") }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-list-item class="font-bold text-left">
                      Consulta:
                      <div class="decoration-solid text-blue-400 ml-1">
                        {{ ConsultaI }}
                      </div>

                      <span class="flex justify-end" v-show="ArchivoI"
                        ><v-icon> mdi-camera</v-icon>
                        <span
                          @click="expandirImagen"
                          style="cursor:pointer"
                          class="hover:underline"
                        >
                          Abrir adjunto
                        </span>
                      </span>
                    </v-list-item>
                    <v-card
                      v-if="itemConsulta"
                      outlined
                      class="ticket-info mb-4"
                    >
                      <div class="ticket-info-grid">
                        <div class="ticket-info-item">
                          <div class="ticket-info-label">Nro. Ticket</div>
                          <div class="ticket-info-value ticket-info-value--strong">
                            #{{ String(itemConsulta).padStart(6, '0') }}
                          </div>
                        </div>
                        <div class="ticket-info-item">
                          <div class="ticket-info-label">Estado</div>
                          <v-chip
                            :class="colorForEstado(Estadoi)"
                            class="pa-2 rounded-xl text-white"
                            small
                          >
                            {{ (Estadoi || '—') | capitalizeFirstLetter }}
                          </v-chip>
                        </div>
                        <div class="ticket-info-item">
                          <div class="ticket-info-label">Categoría</div>
                          <div class="ticket-info-value">{{ CategoriaI || '—' }}</div>
                        </div>
                        <div class="ticket-info-item">
                          <div class="ticket-info-label">Ticket</div>
                          <v-chip
                            small
                            :color="AbiertaI ? 'green' : 'red'"
                            text-color="white"
                            class="px-2"
                          >
                            {{ AbiertaI ? 'Abierto' : 'Cerrado' }}
                          </v-chip>
                        </div>
                      </div>
                      <v-divider class="my-3"></v-divider>
                      <div class="ticket-info-user">
                        <div class="ticket-info-avatar">
                          <span
                            class="ticket-info-initials"
                            :style="{ backgroundColor: avatarUsuarioColor, color: getContrastColor(avatarUsuarioColor) }"
                          >
                            {{ inicialesUsuario }}
                          </span>
                        </div>
                        <div class="ticket-info-user-data">
                          <div class="ticket-info-name">{{ UsuarioI || '—' }}</div>
                          <div class="ticket-info-email">{{ EmailI || '' }}</div>
                        </div>
                        <div class="ticket-info-date">
                          <div class="ticket-info-label">Creado</div>
                          <div class="ticket-info-value">{{ formatFechaHora(CreadoI) }}</div>
                        </div>
                      </div>
                    </v-card>
                    <div
                      ref="scrollContainer"
                      class="ticket-chat"
                      style="max-height: 400px;"
                    >
                      <div
                        v-if="mensajesValidos.length === 0"
                        class="ticket-chat-empty"
                      >
                        <v-icon large color="grey lighten-1">mdi-message-text-outline</v-icon>
                        <span>Sin respuestas aún</span>
                      </div>

                      <div
                        v-for="(msg, index) in mensajesValidos"
                        :key="index"
                        class="ticket-chat-row"
                        :class="{ 'ticket-chat-row-mine': esMensajeMio(msg) }"
                      >
                        <div class="ticket-chat-avatar">
                          <span
                            class="ticket-chat-initials"
                            :style="{ backgroundColor: avatarColor(msg), color: getContrastColor(avatarColor(msg)) }"
                          >
                            {{ iniciales(msg) }}
                          </span>
                        </div>
                        <div class="ticket-chat-bubble">
                          <div class="ticket-chat-meta">
                            <span class="ticket-chat-name">{{ msg.Nombre || msg.Email }}</span>
                            <span class="ticket-chat-time">{{ formatFechaHora(msg.Fecha) }}</span>
                          </div>
                          <div class="ticket-chat-text">{{ msg.Respuesta }}</div>
                          <div
                            v-if="msg.Attachments && msg.Attachments.length"
                            class="ticket-chat-attachments"
                          >
                            <a
                              v-for="(att, i) in msg.Attachments"
                              :key="att.id || att.filename || i"
                              :href="att.url || '#'"
                              target="_blank"
                              rel="noopener"
                              class="ticket-chat-attachment"
                            >
                              <v-icon x-small>mdi-paperclip</v-icon>
                              <span>{{ att.filename || att.archivo || 'Adjunto' }}</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-card-text>

                  <div class="ticket-chat-composer">
                    <textarea
                      v-model="respuesta"
                      class="ticket-chat-composer-textarea"
                      placeholder="Escribe una respuesta..."
                      rows="1"
                      @keydown.enter.prevent="createRespuestaSoporte()"
                    ></textarea>
                    <button
                      type="button"
                      class="ticket-chat-composer-btn"
                      :class="{ 'is-active': archivoRespuestaE }"
                      :title="archivoRespuestaE ? 'Ocultar adjuntos' : 'Adjuntar archivo'"
                      @click="archivoRespuestaE = !archivoRespuestaE"
                    >
                      <v-icon small>mdi-paperclip</v-icon>
                    </button>
                    <button
                      type="button"
                      class="ticket-chat-composer-btn ticket-chat-composer-btn--send"
                      :disabled="!respuesta.trim() || cargandobtn"
                      :title="cargandobtn ? 'Enviando...' : 'Enviar respuesta'"
                      @click="createRespuestaSoporte()"
                    >
                      <v-icon small v-if="!cargandobtn">mdi-send</v-icon>
                      <v-icon small v-else>mdi-loading mdi-spin</v-icon>
                    </button>
                  </div>

                  <div v-if="archivoRespuestaE" class="ticket-chat-composer-attach">
                    <v-file-input
                      v-model="archivoRespuestaC"
                      accept="image/png, image/jpeg, application/pdf"
                      prepend-icon="mdi-camera"
                      label="Archivos"
                      multiple
                      show-size
                      dense
                    ></v-file-input>
                  </div>
                </v-card>
              </v-dialog>
              <!-- fin de modal de respuestas -->

              <!-- Modal de imagen Expandida para visualizar -->
              <v-dialog
                v-model="imagenExpandidaDialog"
                class="rounded-none"
                width="1120"
              >
                <div style="max-width: 70rem;margin:auto">
                  <img
                    :src="ArchivoI.startsWith('http') ? ArchivoI : `${rutaBackendImg}?archivo=${ArchivoI}`"
                    alt="Imagen Soporte"
                    style="cursor: pointer;"
                    width="100%"
                  />
                </div>
              </v-dialog>
              <!-- fin de modal de imagen expandida -->
            </div>
          </v-container>
        </v-main>
      </div>
    </v-app>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import moment from "moment";
import { Soportes } from "../../services/soportes.js";
import ChatSocket from "../../services/chatSocketSoportes.js";
export default {
  name: "Soportes",
  data: () => ({
    cargandobtn: false,
    notifSocket: null,
    itemConsultas: [{ TicketNro: "" }],
    dialogRespuestas: false,
    dialog: false,
    dialogDelete: false,
    dialogEdit: false,
    itemConsulta: "",
    ConsultaI: "",
    ArchivoI: "",
    Estadoi: "",
    CategoriaI: "",
    AbiertaI: false,
    UsuarioI: "",
    EmailI: "",
    CreadoI: "",
    mostrarRegla: false,
    mensajeError: "",
    ticketActual: null,
    attachmentsTicket: [],
    archivoRespuestaC: [],
    archivoRespuestaE: false,
    //  numero de registros por pagina
    rowsPerPageArray: [20, 50, 100, 200],
    imagenExpandidaDialog: false,
    footerProps: {
      "items-per-page-options": [5, 10, 20, 30],
      "items-per-page-text": "Mostrar",
      "prev-icon": "",
      "next-icon": "",
      "page-text": "{0}-{1} de {2}",
    },
    // Header de la tabla
    headers: [
      {
        text: "#",
        align: "start",
        sortable: false,
        value: "Id",
        width: 80,
      },
      // { text: "Cliente", sortable: false, value: "ClientName", width: 150 },
      { text: "Asunto", sortable: false, value: "Asunto" },
      { text: "Usuario", sortable: false, value: "Usuario" },
      { text: "Estado", sortable: false, value: "Abierta", align: "center", width: 90 },
      { text: "Progreso", sortable: false, value: "Estado", width: 150 },
      { text: "Categoría", sortable: false, value: "Categoria", width: 120 },
      { text: "Respuestas", sortable: false, value: "Respuestas", align: "center", width: 80 },
      { text: "Fecha", sortable: false, value: "Fecha", width: 140 },
    ],

    headersConsulta: [
      { text: "Fecha", align: "start", sortable: false, value: "Fecha" }, //ver si trae bien la fecha
      { text: "Usuario", sortable: false, value: "Nombre" },
      { text: "Respuesta", sortable: false, value: "Respuesta" },
      { text: "Archivo", sorteable: false, value: "Archivo" },
    ],

    consultaEdit: "",
    consulta: "",
    asunto: "",
    categoria: "",

    categorias: [],

    archivoC: [],
    archivoCPreviews: [],
    isDragging: false,
    dragCounter: 0,
    maxAdjuntos: 5,
    maxAdjuntosBytes: 8 * 1024 * 1024,
    formValido: false,
    estado: "espera",
    visto: false,
    abierto: false,
    email: "",

    // Filtros (locales, se commitean al store al aplicar)
    searchInput: "",
    estadosFiltroInput: [],
    categoriaFiltroInput: [],
    respuesta: "",
    id: "",

    estados: [
      { text: "Nuevo", sortable: false, value: "nuevo" },
      { text: "Espera", sortable: false, value: "espera" },
      { text: "Resolviendo", sortable: false, value: "resolviendo" },
      { text: "Resuelta", sortable: false, value: "resuelta" },
      { text: "Rechazada", sortable: false, value: "rechazada" },
      {
        text: "Pendiente de Desarrollo",
        sortable: false,
        value: "pendiente de desarrollo",
      },
    ],

    editedIndex: -1,
    rutaBackendImg:
      process.env.VUE_APP_URLPASARELA + "/administracion/soportes-file",
  }),

  filters: {
    capitalizeFirstLetter(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },

  computed: {
    paginaActual: {
      get() {
        return this.$store.getters["soportes/pages"];
      },
    },
    existenSoportes() {
      return this.soportes.length > 0;
    },

    ...mapGetters([
      "getCurrentClientName",
      "getCurrentClientEmail",
      "getCurrentClientId",
      "CLIENTE_CUENTA_DATA",
      "getCurrentAccountId",
      "roles",
    ]),

    ...mapState("soportes", [
      "soportes",
      "page",
      "total",
      "visible",
      "rowsPerPage",
      "cargando",
      "sinVinculoSoporte",
      "mensajeVinculo",
      "errorMensaje",
      "mensajeExito",
    ]),

    reglaConsulta() {
      return this.mostrarRegla
        ? [(v) => !!v || "Este campo no puede estar vacio"]
        : [];
    },

    categoriasOptions() {
      // Mapea las categorías del back al formato que espera v-select ({text, value}).
      // Acepta objetos {name|text|label} o strings sueltos.
      if (!this.categorias || this.categorias.length === 0) {
        return [];
      }
      return this.categorias
        .map((c) => {
          if (typeof c === "string") return { text: c, value: c };
          const name = c?.name ?? c?.text ?? c?.label ?? c?.value;
          if (!name) return null;
          return { text: name, value: name };
        })
        .filter(Boolean);
    },

    // Opciones del filtro de categoría = categorías del cliente + centinela
    // "Sin categoría" (__sin__) para tickets con categoria NULL/vacía. Es un
    // computed aparte para que __sin__ NO aparezca al crear un ticket nuevo.
    categoriasFiltroOptions() {
      return [
        { text: "Sin categoría", value: "__sin__" },
        ...this.categoriasOptions,
      ];
    },

    hayFiltrosActivos() {
      return !!(
        this.searchInput ||
        (this.estadosFiltroInput && this.estadosFiltroInput.length > 0) ||
        (this.categoriaFiltroInput && this.categoriaFiltroInput.length > 0)
      );
    },

    mensajesValidos() {
      // Filtra entradas vacías/placeholder que el data() inicial pueda traer.
      return (this.itemConsultas || []).filter(m => m && m.Respuesta);
    },

    inicialesUsuario() {
      return this.iniciales({ Nombre: this.UsuarioI, Email: this.EmailI });
    },

    avatarUsuarioColor() {
      const t = this.ticketActual || {};
      const color = t.client_color || t.ClientColor || '';
      return color.startsWith('#') ? color : (color ? '#' + color : '#6366f1');
    },
  },

  watch: {
    // Observa los cambios en itemConsultas y realiza scroll al final
    itemConsultas() {
      this.$nextTick(() => {
        this.scrollContainerToBottom();
      });
    },

    // Cambio de cliente (selector global): recargar la vista con los tickets
    // del cliente nuevo. Las categorías son por-cliente, así que limpiamos los
    // filtros, recargamos el catálogo y volvemos a la página 1. El socket de
    // notificaciones queda atado al cliente anterior, por eso se reconecta.
    getCurrentClientId(nuevoId, anteriorId) {
      if (!nuevoId || nuevoId === anteriorId) return;
      this.searchInput = "";
      this.estadosFiltroInput = [];
      this.categoriaFiltroInput = [];
      this.$store.commit("soportes/setSearch", "");
      this.$store.commit("soportes/setEstadosFiltro", []);
      this.$store.commit("soportes/setCategoriaFiltro", []);
      this.$store.commit("soportes/setPaginate", 1);
      this.cargarCategorias();
      this.getSoportes();
      this.conectarNotificaciones();
    },
  },

  async created() {
    this.email = this.getCurrentClientEmail;
    this.nombre = this.getCurrentClientName;
    // Sincronizar filtros locales con el state (por si el usuario volvió
    // desde el detalle y mantiene los filtros aplicados).
    this.searchInput = this.$store.state.soportes.search || "";
    this.estadosFiltroInput = this.$store.state.soportes.estadosFiltro || [];
    this.categoriaFiltroInput = this.$store.state.soportes.categoriaFiltro || [];
    await this.cargarCategorias();
    this.getSoportes();
    // Tiempo real: refrescar la lista cuando soporte avisa cambios del cliente.
    this.conectarNotificaciones();
  },

  beforeDestroy() {
    this.desconectarNotificaciones();
  },

  methods: {
    ...mapActions("soportes", [
      "createSoporte",
      "getSoportes",
      "getSoporteFile",
      "putSoporte",
      "createSoporteRespuesta",
      "getSoporteDetail",
      "markSoporteRead",
      "listSoporteAttachments",
      "getRealtimeToken",
    ]),

    // Notificaciones en vivo del cliente (badge / refresco de lista, guía §8.5).
    conectarNotificaciones() {
      if (!this.getCurrentClientId) return;
      this.desconectarNotificaciones();
      this.notifSocket = new ChatSocket({
        kind: "notifications",
        getToken: () => this.getRealtimeToken(),
        onMessage: (data) => this.onNotificacion(data),
        onStatus: () => {},
      });
      this.notifSocket.connect();
    },

    desconectarNotificaciones() {
      if (this.notifSocket) {
        this.notifSocket.close();
        this.notifSocket = null;
      }
    },

    onNotificacion(data) {
      if (!data || typeof data !== "object") return;
      const type = data.type || data.event;
      if (type === "tickets.changed" || type === "response.created") {
        // El WS solo avisa "algo cambió"; la fuente de verdad es el REST.
        this.getSoportes();
      }
    },

    expandirImagen() {
      // Abrir el modal para mostrar la imagen a tamaño completo
      this.imagenExpandidaDialog = true;
    },

    scrollContainerToBottom() {
      // Obtén el elemento del contenedor de referencia
      const container = this.$refs.scrollContainer;
      // Haz scroll hasta el fondo
      container.scrollTop = container.scrollHeight;
    },

    getContrastColor(hexColor) {
      if (!hexColor) return '#ffffff';
      let hex = hexColor.startsWith('#') ? hexColor.slice(1) : hexColor;
      if (hex.length === 3) hex = hex.split('').map(x => x + x).join('');
      const r = parseInt(hex.substr(0, 2), 16);
      const g = parseInt(hex.substr(2, 2), 16);
      const b = parseInt(hex.substr(4, 2), 16);
      const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
      return (yiq >= 128) ? '#000000' : '#ffffff';
    },

    esMensajeMio(msg) {
      return !!(this.email && msg && msg.Email && msg.Email.toLowerCase() === this.email.toLowerCase());
    },

    avatarColor(msg) {
      // Verde primario (consistente con theme.primary del proyecto) para
      // mensajes del usuario actual; azul (mismo color que .user-responder en
      // la tabla) para el resto.
      return this.esMensajeMio(msg) ? '#50b565' : '#1976d2';
    },

    iniciales(msg) {
      const nombre = (msg && (msg.Nombre || msg.Email)) || '';
      if (!nombre) return '?';
      const partes = String(nombre).trim().split(/\s+/);
      if (partes.length === 1) return partes[0].substring(0, 2).toUpperCase();
      return (partes[0][0] + partes[partes.length - 1][0]).toUpperCase();
    },

    formatFechaHora(value) {
      if (!value) return '';
      const m = moment(value, "DD-MM-YYYY HH:mm:ss", true);
      if (m.isValid()) return m.format("DD/MM/yyyy HH:mm");
      return value;
    },

    async cargarCategorias() {
      try {
        const res = await Soportes.getCategorias(
          this.getCurrentClientId,
          this.getCurrentClientEmail
        );
        this.categorias = this.normalizeCategorias(res);
      } catch (e) {
        console.warn("No se pudieron cargar categorías:", e);
        if (this.$toastr) {
          this.$toastr.w("No se pudieron cargar las categorías");
        }
      }
    },

    normalizeCategorias(res) {
      // Acepta: array directo, array de strings, array de objetos {name},
      // o respuestas envueltas ({data}, {categories}, {items}, {results}).
      let arr = res;
      if (arr && typeof arr === "object" && !Array.isArray(arr)) {
        arr = arr.data || arr.categories || arr.items || arr.results || [];
      }
      if (!Array.isArray(arr)) return [];
      return arr
        .map((c) => (typeof c === "string" ? { name: c } : c))
        .filter((c) => c && (c.name || c.text || c.label));
    },

    colorForEstado(estado) {
      switch (estado?.toLowerCase()) {
        case "nuevo":
          return "indigo";
        case "espera":
          return "amber";
        case "resolviendo":
          return "blue";
        case "resuelta":
          return "green";
        case "rechazada":
          return "red";
        case "pendiente de desarrollo":
          return "orange";
        default:
          return "";
      }
    },

    isSuperAdmin() {
      if (this.roles.find((r) => r == "psp.config.clientes.wee")) {
        return true; //true
      }
      return false; //false
    },

    resetConsulta() {
      this.consulta = "";
      this.asunto = "";
      this.categoria = "";
      this.revokeAllPreviews();
      this.archivoC = [];
      this.archivoCPreviews = [];
      this.isDragging = false;
      this.dragCounter = 0;
      if (this.$refs.formSoporte) this.$refs.formSoporte.resetValidation();
      this.mostrarRegla = false;
    },
    triggerFileInput() {
      const input = this.$refs.ticketFileInput;
      if (input) input.click();
    },
    onFilePickerChange(event) {
      const files = event.target.files;
      this.agregarArchivos(files);
      event.target.value = "";
    },
    onDragEnter() {
      this.dragCounter += 1;
      this.isDragging = true;
    },
    onDragOver() {
      if (!this.isDragging) this.isDragging = true;
    },
    onDragLeave() {
      this.dragCounter = Math.max(0, this.dragCounter - 1);
      if (this.dragCounter === 0) this.isDragging = false;
    },
    onDrop(event) {
      this.dragCounter = 0;
      this.isDragging = false;
      const files = event.dataTransfer && event.dataTransfer.files;
      this.agregarArchivos(files);
    },
    agregarArchivos(files) {
      if (!files || files.length === 0) return;
      const incoming = Array.from(files);
      const espacio = this.maxAdjuntos - this.archivoC.length;
      const aceptados = [];
      const rechazados = [];
      incoming.forEach((file) => {
        if (!file.type || !file.type.startsWith("image/")) {
          rechazados.push({ file, reason: "tipo" });
          return;
        }
        if (file.size > this.maxAdjuntosBytes) {
          rechazados.push({ file, reason: "tamaño" });
          return;
        }
        if (aceptados.length >= espacio) {
          rechazados.push({ file, reason: "limite" });
          return;
        }
        aceptados.push(file);
      });

      if (aceptados.length) {
        this.archivoC = [...this.archivoC, ...aceptados];
        this.generarPreviews(aceptados);
      }

      if (rechazados.length) {
        this.mostrarErroresAdjuntos(rechazados);
      }
    },
    mostrarErroresAdjuntos(rechazados) {
      if (!rechazados.length || !this.$toastr) return;
      const tieneTipo = rechazados.some((r) => r.reason === "tipo");
      const tieneTam = rechazados.some((r) => r.reason === "tamaño");
      const tieneLim = rechazados.some((r) => r.reason === "limite");
      if (tieneTipo) {
        this.$toastr.w("Algunos archivos no son imágenes y fueron ignorados.");
      }
      if (tieneTam) {
        this.$toastr.w("Algunos archivos superan 8MB y fueron ignorados.");
      }
      if (tieneLim) {
        this.$toastr.w(`Máximo ${this.maxAdjuntos} archivos adjuntos.`);
      }
    },
    generarPreviews(nuevosArchivos) {
      nuevosArchivos.forEach((file) => {
        if (file.type && file.type.startsWith("image/")) {
          this.archivoCPreviews.push(URL.createObjectURL(file));
        } else {
          this.archivoCPreviews.push("");
        }
      });
    },
    eliminarPreview(index) {
      const preview = this.archivoCPreviews[index];
      if (preview) URL.revokeObjectURL(preview);
      this.archivoCPreviews.splice(index, 1);
      this.archivoC.splice(index, 1);
    },
    revokeAllPreviews() {
      this.archivoCPreviews.forEach((p) => {
        if (p) URL.revokeObjectURL(p);
      });
    },
    formatBytes(bytes) {
      if (!bytes && bytes !== 0) return "";
      if (bytes < 1024) return `${bytes} B`;
      if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
      return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    },
    resetRespuesta() {
      this.respuesta = "";
      this.archivoRespuestaC = [];
      this.archivoRespuestaE = false;
      this.mostrarRegla = false;
    },

    //Modal de Respuestas
    async showDetails(item) {
      this.dialogRespuestas = true;
      this.ConsultaI = item.Asunto || item.Consulta;
      this.ArchivoI = item.Archivo;
      this.attachmentsTicket = [];
      this.itemConsultas = [];

      try {
        // El external_id (cliente) lo fija el back desde la sesión: solo el id del ticket.
        const data = await this.getSoporteDetail({ ticketId: item.Id, includeThumbs: true });
        this.ticketActual = data.ticket || null;
        this.itemConsulta = item.Id;
        if (this.ticketActual) {
          this.ConsultaI = this.ticketActual.asunto || this.ticketActual.consulta || this.ConsultaI;
          this.CategoriaI = this.ticketActual.categoria || '';
          this.Estadoi = this.ticketActual.estado || '';
          this.AbiertaI = !!this.ticketActual.abierta;
          this.UsuarioI = this.ticketActual.creator_name || this.ticketActual.creator_email || 'Sin usuario';
          this.EmailI = this.ticketActual.creator_email || '';
          this.CreadoI = this.ticketActual.created_at || '';
        }
        this.attachmentsTicket = data.attachments || [];
        this.itemConsultas = (data.responses || []).map(r => ({
          Email: r.user_email || r.creator_email,
          Nombre: r.user_name || r.creator_name || r.user_email || r.creator_email,
          Fecha: moment(r.created_at).format("DD-MM-yyyy HH:mm:ss"),
          Respuesta: r.respuesta,
          Attachments: r.attachments || [],
        }));
        if (this.attachmentsTicket.length > 0) {
          this.ArchivoI = this.attachmentsTicket[0].url || this.attachmentsTicket[0].archivo;
        }

        // Marcar como leído.
        try {
          await this.markSoporteRead({ ticketId: item.Id });
        } catch (e) {
          console.warn("No se pudo marcar como leído:", e);
        }
      } catch (e) {
        this.$toastr.e(e.userMessage || "No se pudo obtener el detalle del ticket.");
        console.error("Error obteniendo detalles del ticket:", e);
      }
    },

    // paginar datatable
    onPageChange(event) {
      this.$store.commit("soportes/setPaginate", event);
      this.getSoportes();
    },

    // registros por paginas (actualizar numero de registros por pagina) (listo)
    updateRowsPerPage(number) {
      this.$store.commit("soportes/setrowsPerPage", number);
      this.$store.commit("soportes/setPaginate", 1);
      this.getSoportes();
    },

    formatFecha(value) {
      var date = new Date(value);
      let fecha = date.toISOString().substring(0, 10);
      var datePart = fecha.match(/\d+/g),
        year = datePart[0].substring(0),
        month = datePart[1],
        day = datePart[2];

      return day + "/" + month + "/" + year;
    },

    irADetalle(item) {
      this.$router.push({ name: "SoporteDetalle", params: { id: item.Id } });
    },

    aplicarFiltros() {
      // Commitear los inputs locales al store y resetear a página 1.
      this.$store.commit("soportes/setSearch", this.searchInput || "");
      this.$store.commit("soportes/setEstadosFiltro", this.estadosFiltroInput || []);
      this.$store.commit("soportes/setCategoriaFiltro", this.categoriaFiltroInput || []);
      this.$store.commit("soportes/setPaginate", 1);
      this.getSoportes();
    },

    limpiarFiltros() {
      this.searchInput = "";
      this.estadosFiltroInput = [];
      this.categoriaFiltroInput = [];
      this.$store.commit("soportes/setSearch", "");
      this.$store.commit("soportes/setEstadosFiltro", []);
      this.$store.commit("soportes/setCategoriaFiltro", []);
      this.$store.commit("soportes/setPaginate", 1);
      this.getSoportes();
    },

    // Funciones de CRUD

    //Crear Soportes
    async save() {
      try {
        // Validar campos obligatorios
        if (!this.consulta.trim() || !this.asunto.trim()) {
          this.mostrarRegla = true;
          return;
        }
        this.cargandobtn = true;
        
        const payload = {
          asunto: this.asunto,
          consulta: this.consulta,
          categoria: this.categoria,
          prioridad: 1,
        };

        if (this.archivoC && this.archivoC.length) {
          payload.attachments = [...this.archivoC];
        }

        await this.createSoporte(payload);
        this.cargandobtn = false;
        this.dialog = false;
        this.$toastr.s("Ticket creado correctamente");
        this.getSoportes();
        this.resetConsulta();
      } catch (error) {
        this.cargandobtn = false;
        this.$toastr.e(error.userMessage
          || "No se pudo crear el ticket. Intente nuevamente.");
      }
    },

    //Editar Soporte - Estado
    async editarSoporte() {
      try {
        const ticketId = this.itemConsulta || this.id;
        if (!ticketId) {
          this.mensajeError = "No se pudo determinar el ticket.";
          return;
        }
        const nuevosDatos = {
          id: ticketId,
          visto: true,
          estado: this.Estadoi,
          abierto: this.AbiertaI,
        };
        await this.$store.dispatch("soportes/editarSoporte", {
          nuevosDatos,
        });
        this.$store.commit("soportes/setMensajeExito", "Estado del ticket actualizado");
        this.getSoportes();
      } catch (error) {
        this.mensajeError = error.userMessage
          || "No se pudo actualizar el estado del ticket.";
        console.error("Error editando soporte:", error);
      }
    },

    //Guardar Respuesta
    async createRespuestaSoporte() {
      try {
        if (!this.respuesta.trim()) {
          this.mostrarRegla = true;
          return;
        }

        // Solo necesitamos el id del ticket; el external_id lo fija el back.
        const ticketId = this.itemConsulta || this.id;
        if (!ticketId) {
          this.mensajeError = "No se pudo determinar el ticket.";
          return;
        }

        const tieneArchivo = this.archivoRespuestaC && this.archivoRespuestaC.length > 0;

        let respuestaPayload;
        if (tieneArchivo) {
          // Multipart con archivo adjunto.
          respuestaPayload = new FormData();
          respuestaPayload.append("soportesId", ticketId);
          respuestaPayload.append("respuesta", this.respuesta);
          for (const f of this.archivoRespuestaC) {
            respuestaPayload.append("file", f);
          }
        } else {
          // JSON sin archivo.
          respuestaPayload = {
            soportesId: ticketId,
            respuesta: this.respuesta,
          };
        }

        this.cargandobtn = true;
        await this.createSoporteRespuesta(respuestaPayload);
        this.cargandobtn = false;

        // Optimistic update: agregar al chat localmente.
        this.itemConsultas = [
          ...this.itemConsultas,
          {
            Email: this.email,
            Nombre: this.nombre,
            Fecha: moment().format("DD-MM-yyyy HH:mm:ss"),
            Visto: true,
            Respuesta: this.respuesta,
            Attachments: tieneArchivo
              ? (this.archivoRespuestaC || []).map(f => ({ filename: f.name }))
              : [],
          },
        ];

        // Refrescar el detalle para traer la respuesta canónica del back.
        try {
          await this.showDetails({ Id: ticketId });
        } catch (e) {
          console.warn("No se pudo refrescar el detalle:", e);
        }

        this.$store.commit("soportes/setMensajeExito", "Respuesta enviada correctamente");
        this.resetRespuesta();
      } catch (error) {
        this.cargandobtn = false;
        this.mensajeError = error.userMessage
          || "No se pudo enviar la respuesta. Intente nuevamente.";
        console.error("Error al crear respuesta de soporte:", error);
      }
    },

    // deleteItem(item) {
    //   this.editedIndex = this.soportes1.indexOf(item);
    //   this.editedItem = Object.assign({}, item);
    //   this.dialogDelete = true;
    // },

    // deleteItemConfirm() {
    //   this.soportes1.splice(this.editedIndex, 1);
    //   this.closeDelete();
    // },

    // closeDelete() {
    //   this.dialogDelete = false;
    //   this.$nextTick(() => {
    //     this.editedItem = Object.assign({}, this.defaultItem);
    //     this.editedIndex = -1;
    //   });
    // },
  },
};
</script>

<style scoped>
::v-deep .v-data-table tbody tr {
  cursor: pointer;
}

.user-responder {
  color: #1976d2;
  font-weight: 500;
}
.user-creator {
  color: inherit;
}

/* Chat de respuestas del ticket */
.ticket-chat {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px;
  background-color: #f5f7fa;
  border-radius: 8px;
  overflow-y: auto;
}

.ticket-chat-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 32px 16px;
  color: #9e9e9e;
  font-size: 0.875rem;
}

.ticket-chat-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  max-width: 85%;
}

.ticket-chat-row-mine {
  flex-direction: row-reverse;
  align-self: flex-end;
}

.ticket-chat-avatar {
  flex-shrink: 0;
}

.ticket-chat-initials {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  user-select: none;
}

.ticket-chat-bubble {
  background: #ffffff;
  padding: 8px 12px;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
  min-width: 0;
  word-break: break-word;
}

.ticket-chat-row-mine .ticket-chat-bubble {
  background: #e8f5e9;
  border-bottom-right-radius: 4px;
}

.ticket-chat-row:not(.ticket-chat-row-mine) .ticket-chat-bubble {
  border-bottom-left-radius: 4px;
}

.ticket-chat-meta {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 2px;
  font-size: 0.75rem;
}

.ticket-chat-name {
  font-weight: 600;
  color: #1976d2;
}

.ticket-chat-row-mine .ticket-chat-name {
  color: #2e7d32;
}

.ticket-chat-time {
  color: #9e9e9e;
  font-weight: 400;
}

.ticket-chat-text {
  font-size: 0.875rem;
  color: #212121;
  white-space: pre-wrap;
  line-height: 1.4;
}

.ticket-chat-attachments {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
}

.ticket-chat-attachment {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.75rem;
  color: #1976d2;
  background: #f1f5f9;
  padding: 2px 8px;
  border-radius: 12px;
  text-decoration: none;
}

.ticket-chat-attachment:hover {
  text-decoration: underline;
}

/* Composer de envío (debajo del chat) */
.ticket-chat-composer {
  display: flex;
  align-items: flex-end;
  gap: 6px;
  margin: 12px 20px 16px;
  padding: 6px 6px 6px 16px;
  background: #f5f7fa;
  border: 1px solid #e6e8eb;
  border-radius: 24px;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.ticket-chat-composer:focus-within {
  border-color: #50b565;
  box-shadow: 0 0 0 2px rgba(80, 181, 101, 0.12);
}

.ticket-chat-composer-textarea {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  resize: none;
  font-family: inherit;
  font-size: 0.875rem;
  line-height: 1.4;
  color: #212121;
  max-height: 120px;
  min-height: 24px;
  padding: 6px 0;
}

.ticket-chat-composer-textarea::placeholder {
  color: #9e9e9e;
}

.ticket-chat-composer-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: transparent;
  color: #757575;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.2s, color 0.2s;
  padding: 0;
}

.ticket-chat-composer-btn:hover:not(:disabled) {
  background: rgba(0, 0, 0, 0.05);
  color: #212121;
}

.ticket-chat-composer-btn.is-active {
  color: #50b565;
  background: rgba(80, 181, 101, 0.12);
}

.ticket-chat-composer-btn--send {
  background: #50b565;
  color: #fff;
}

.ticket-chat-composer-btn--send:hover:not(:disabled) {
  background: #449954;
  color: #fff;
}

.ticket-chat-composer-btn--send:disabled {
  background: #c8e6c9;
  color: #fff;
  cursor: not-allowed;
  opacity: 0.7;
}

.ticket-chat-composer-attach {
  margin: 0 20px 12px;
  padding: 8px 12px;
  background: #fafbfc;
  border: 1px solid #e6e8eb;
  border-radius: 8px;
}

/* Card de información del ticket (sobre el chat) */
.ticket-info {
  background-color: #fafbfc;
  border-color: #e6e8eb !important;
  border-radius: 10px;
  padding: 14px 16px;
}

.ticket-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px 24px;
}

.ticket-info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.ticket-info-label {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #8a8d93;
  font-weight: 600;
}

.ticket-info-value {
  font-size: 0.875rem;
  color: #2c3e50;
  word-break: break-word;
}

.ticket-info-value--strong {
  font-weight: 600;
  color: #1976d2;
}

.ticket-info-user {
  display: flex;
  align-items: center;
  gap: 12px;
}

.ticket-info-avatar {
  flex-shrink: 0;
}

.ticket-info-initials {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  user-select: none;
}

.ticket-info-user-data {
  flex: 1;
  min-width: 0;
}

.ticket-info-name {
  font-size: 0.875rem;
  font-weight: 600;
  color: #2c3e50;
  word-break: break-word;
}

.ticket-info-email {
  font-size: 0.75rem;
  color: #8a8d93;
  word-break: break-word;
}

.ticket-info-date {
  text-align: right;
  flex-shrink: 0;
}

/* ============================== */
/* Modal crear nuevo ticket       */
/* ============================== */
.drop-zone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 24px 16px;
  border: 2px dashed #bdbdbd;
  border-radius: 4px;
  background: #fafafa;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.drop-zone:hover {
  border-color: #1976d2;
  background: #f5f5f5;
}
.drop-zone--active {
  border-color: #1976d2;
  border-style: solid;
  background: #e3f2fd;
}
.drop-zone--has {
  border-style: solid;
  border-color: #e0e0e0;
  background: #fafafa;
  padding: 12px 16px;
}

.drop-zone__input {
  display: none;
}

.drop-zone__title {
  font-size: 0.9rem;
  color: #424242;
  font-weight: 500;
}

.drop-zone__hint {
  font-size: 0.75rem;
  color: #757575;
  margin-top: 4px;
}

/* Preview list */
.preview-list {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.preview-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 8px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: #ffffff;
}

.preview-item__thumb {
  width: 36px;
  height: 36px;
  border-radius: 4px;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
}
.preview-item__thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.preview-item__info {
  flex: 1 1 auto;
  min-width: 0;
}

.preview-item__name {
  font-size: 0.8rem;
  color: #212121;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.preview-item__size {
  font-size: 0.7rem;
  color: #757575;
  margin-top: 1px;
}
</style>
